import { couponUnlockCodeExportAll } from "@saleor/coupons/mutations";
import useNotifier from "@saleor/hooks/useNotifier";
import { useMutation } from "react-apollo";
import { useIntl } from "react-intl";

import { downloadBase64Excel } from "../../UnlockCodesTable/utils";

const useExportAllApi = () => {
  const intl = useIntl();
  const notify = useNotifier();
  const [exportAllMutation, { loading }] = useMutation(
    couponUnlockCodeExportAll
  );

  const exportAll = (couponId: string, couponName: string) => () => {
    exportAllMutation({
      variables: {
        couponId
      }
    })
      .then(response => {
        downloadBase64Excel(
          response.data.couponUnlockCodeExportAll.fileUrl,
          `${couponName}-UnlockCodes`
        );
        notify({
          status: "success",
          text: intl.formatMessage({
            defaultMessage: "Unlock Code(s) downloaded successfully."
          })
        });
      })
      .catch(() => {
        notify({
          status: "error",
          text: intl.formatMessage({
            defaultMessage: "An error occured."
          })
        });
      });
  };

  return { exportAll, isLoading: loading };
};

export default useExportAllApi;
